import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import Lightbox from 'react-image-lightbox';

export default class InformationIntro extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  photoIndex: 0,
		  isOpen: false
		};
	}
	render() {
		const { isOpen } = this.state;
		return (
			<div className="informationGrid">
				<div className="introImage" onClick={() => this.setState({ isOpen: true })}>
					<LazyLoad height={150}>
						<img src={this.props.imageSrc} alt="Intro" />
					</LazyLoad>
					{isOpen && (
		          	<Lightbox
			            mainSrc={this.props.imageSrcHq}
			            onCloseRequest={() => this.setState({ isOpen: false })}
			          />
			        )}
				</div>
				<div className={this.props.informationContent}>
					<h3 className={this.props.h3className}>{this.props.Title}</h3>
					<h4 className={this.props.h4SubclassName}>{this.props.SubTitle}</h4>
					<p className={this.props.pClassName}>{this.props.children}</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/InformationItem/Information-IntroItem.jsx